import messages from './account-number-input-lang.json';
export default {
	data() {
		return {};
	},
	props: {
		value: {
			required: true
		},
		inputRef: {
			required: false
		},
		fieldError: {
			required: true
		}
	},
	i18n: { messages },
	methods: {
		onKeyPress(e) {
			this.validate(e);
			e.target.value = this.formatNumber(e.target.value);
		},
		onPaste(e) {
			e.preventDefault();
			// nem szamok kiszurese
			let clipboardData = e.clipboardData || window.clipboardData;
			let pasted = clipboardData.getData('Text').replace(/\D/g, '');
			// 117 lecsereles
			if (pasted.indexOf('117') == 0) {
				pasted = pasted.substring(3);
			}
			// maxlength levagas
			pasted = pasted.substring(0, 21);
			let start = e.target.selectionStart;
			let finish = e.target.selectionEnd;
			let withoutSelected = e.target.value.substring(0, start) + e.target.value.substring(finish, e.target.value.length).replace(/\D/g, '');
			e.target.value = this.formatNumber(withoutSelected + pasted);
			this.$emit('input', e.target.value);
			this.$emit('paste', e);
		},
		validate(e) {
			// csak szamokat engedjen
			if (e.which && !e.ctrlKey && !e.metaKey && e.which != 8 && e.which != 46 && e.which != 37 && e.which != 39 && isNaN(String.fromCharCode(e.which))) {
				e.preventDefault();
			}
		},
		formatNumber(number) {
			let formattedNumber = '';
			if (number) {
				number = number.replace(/-/gim, '');
				if (number.length < 5) {
					formattedNumber = number;
				} else if (number.length >= 13) {
					formattedNumber = number.substring(0, 5) + '-' + number.substring(5, 13) + '-' + number.substring(13);
				} else if (number.length >= 5) {
					formattedNumber = number.substring(0, 5) + '-' + number.substring(5, 13);
				}
				setTimeout(() => {
					if (
						this.$refs['account-number-input'] &&
						this.$refs['account-number-input'].offsetParent &&
						this.$refs['account-number-input'] == document.activeElement
					) {
						this.$refs['account-number-input'].selectionStart = this.$refs['account-number-input'].selectionEnd = 10000;
					}
				}, 0);
			}
			return formattedNumber;
		}
	}
};
